"use client";
//#region packages/@mantine/core/src/core/utils/find-element-ancestor/find-element-ancestor.ts
function findElementAncestor(element, selector) {
	let _element = element;
	while ((_element = _element.parentElement) && !_element.matches(selector));
	return _element;
}
//#endregion
export { findElementAncestor };

//# sourceMappingURL=find-element-ancestor.mjs.map